import { RootState } from '../../../../store/store';
import { useSelector } from 'react-redux';
import { gql, useMutation } from '@apollo/client';
import { TextInput } from '../../../../types/schema/utils.types';

const GQL_MUT = gql`
  mutation DeleteCorsDomain($input: TextInput!) {
    deleteCorsDomain(input: $input)
  }
`;

// Define the types for the mutation response and input
interface DeleteCorsDomainMutationData {
  deleteCorsDomain: boolean;
}

interface DeleteCorsDomainInputType {
  input: TextInput;
}

export const useDeleteCorsDomain = () => {
  const { jwt } = useSelector((state: RootState) => state.auth);

  const [deleteCorsDomainGql, { data, error, loading }] = useMutation<
    DeleteCorsDomainMutationData,
    DeleteCorsDomainInputType
  >(GQL_MUT);

  const deleteCorsDomain = async (input: TextInput) => {
    const { data, errors } = await deleteCorsDomainGql({
      variables: {
        input: input,
      },
      context: {
        headers: {
          cookie: `jwt=${jwt}`,
          authorization: jwt ? `Bearer ${jwt}` : '',
        },
      },
    });

    return {
      deleteCorsDomain: data?.deleteCorsDomain,
      error: errors ? errors[0].message : null,
    };
  };

  return { deleteCorsDomain, data, error, loading };
};
